import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/more.svg'
import _imports_1 from '@/assets/icons/target.svg'


const _withScopeId = n => (_pushScopeId("data-v-10d78da0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row items-center mb-8 pt-4 justify-between space-x-3 mt-4" }
const _hoisted_2 = { class: "flex flex-row w-full" }
const _hoisted_3 = { class: "flex flex-row items-center justify-end" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Add new collaborator")
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "flex flex-row justify-start" }
const _hoisted_7 = { class: "flex flex-row justify-start" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 4 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "absolute flex flex-col text-black bg-white right-0 mr-10 mt-4 rounded-2xl shadow hover:shadow-md p-2 w-72 z-50"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Remove collaborator")
], -1))
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_VueTableLite = _resolveComponent("VueTableLite")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_ModalAddMember = _resolveComponent("ModalAddMember")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_SearchInput, {
            modelValue: _ctx.inputValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
            class: "bg-white",
            placeholder: "Search for a collaborator...",
            onOnSubmit: _ctx.getCompanies
          }, null, 8, ["modelValue", "onOnSubmit"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "space-x-3 btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-between truncate text-base bg-primary rounded-full transition duration-150 ease-in",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal = !_ctx.openModal))
          }, _hoisted_5)
        ])
      ]),
      _createVNode(_component_VueTableLite, {
        "is-loading": _ctx.table.isLoading,
        columns: _ctx.table.columns,
        rows: _ctx.table.rows,
        total: _ctx.table.totalRecordCount,
        sortable: _ctx.table.sortable,
        "is-slot-mode": true,
        "is-hide-paging": true
      }, {
        name: _withCtx((data) => [
          _createElementVNode("div", null, _toDisplayString(data.value.name), 1)
        ]),
        email: _withCtx((data) => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(data.value.email), 1)
          ])
        ]),
        role: _withCtx((data) => [
          _createElementVNode("div", _hoisted_7, [
            (data.value.role === 'internal_recruiter')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Internal Recruiter"))
              : _createCommentVNode("", true),
            (data.value.role === 'superadmin')
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Superadmin"))
              : _createCommentVNode("", true),
            (data.value.role === 'internal_hr')
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Internal HR"))
              : _createCommentVNode("", true),
            (data.value.role === 'n_a')
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "N/A"))
              : _createCommentVNode("", true),
            (data.value.role === 'recruiter_admin')
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Recruiter Admin"))
              : _createCommentVNode("", true)
          ])
        ]),
        menu: _withCtx((data) => [
          _createElementVNode("button", {
            class: "px-2",
            onClick: ($event: any) => (_ctx.openDropDown(data.value))
          }, _hoisted_15, 8, _hoisted_13),
          (data.value.id === _ctx.currentDropdown)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("button", {
                  class: "hover:bg-background p-4 rounded",
                  onClick: ($event: any) => (_ctx.deactivateClient(data.value.id_relacion))
                }, _hoisted_19, 8, _hoisted_17)
              ])), [
                [_directive_click_away, _ctx.closeMenu]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-loading", "columns", "rows", "total", "sortable"]),
      _createVNode(_component_Paginator, {
        modelValue: _ctx.page,
        page: _ctx.page,
        pages: _ctx.pagination.total_pages,
        "range-size": 1,
        "onUpdate:modelValue": _ctx.updateHandler,
        total: _ctx.pagination.total_count,
        from: _ctx.pagination.from,
        to: _ctx.pagination.to
      }, null, 8, ["modelValue", "page", "pages", "onUpdate:modelValue", "total", "from", "to"])
    ]),
    (_ctx.openModal)
      ? (_openBlock(), _createBlock(_component_ModalAddMember, {
          key: 0,
          openModal: _ctx.openModal,
          "onUpdate:openModal": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.openModal) = $event))
        }, null, 8, ["openModal"]))
      : _createCommentVNode("", true)
  ], 64))
}